import {
    MeshStandardMaterial,
    // CanvasTexture,
    // MeshPhysicalMaterial,
    // Color,
} from "three";

// const simpleNormalMap = (width, height) => {
//     const canvas = document.createElement("canvas");
//     canvas.width = width;
//     canvas.height = height;

//     const ctx = canvas.getContext("2d");

//     ctx.fillStyle = "rgb(128, 127, 255)";
//     ctx.fillRect(0, 0, canvas.width, canvas.height);

//     const normalMap = new CanvasTexture(canvas);

//     return normalMap;
// };

export const getMaterial = (type, color = "#ffffff", opacity = 1) => {
    // if (type === "metal")
    //     return new MeshPhysicalMaterial({
    //         clearcoat: 1,
    //         roughness: 0.2,
    //         clearcoatRoughness: 0.1,
    //         metalness: 1,
    //         sheen: 0.4,
    //         sheenColor: new Color(color),
    //         // emissiveIntensity: 1,
    //         // sheenRoughness: 0.5,
    //         // emissive: "rgb(60, 60, 60)",
    //         opacity: 1,
    //         transparent: false,
    //         transmission: 0,
    //         map: null,
    //         normalMap: simpleNormalMap(500, 500),
    //     });
    const materialType = {
        metal: {
            metalness: 1,
            roughness: 0.1,
            // emissive: new Color(color),
            emissive: color,
            emissiveIntensity: 0.2,
            // normalMap: simpleNormalMap(500, 500),
        },

        wood: {
            roughness: 0.5,
            // emissive: new Color(color),
            // emissive: color,
            // emissiveIntensity: 0.15,
        },

        wall: {
            roughness: 1,
        },
        textile: { roughness: 1 },
        glass: {
            opacity,
            transparent: true,
        },

        emissive: {
            emissive: color,
            emissiveIntensity: 1,
        },

        frostedGlass: {
            roughness: 0.2,
            transparent: true,
            opacity: 0.8,
        },
        ceramic: {
            metalness: 0.2,
            roughness: 0.8,
        },
        marble: {
            metalness: 0.1,
            roughness: 0.2,
        },

        plastic: {
            roughness: 0.6,
        },
    };

    const material = new MeshStandardMaterial({
        // color: new Color(color),
        color,
        ...materialType[type],
    });
    return material;
};
